import React, { useEffect, useState } from 'react';
import type { FC } from 'react';

import type { TAlfaleasingModalWrapper } from './models';

export const AlfaleasingModalWrapper: FC<TAlfaleasingModalWrapper> = ({
    DesktopWrapper,
    MobileWrapper,
    children,
    eventName,
    isMobile = false,
    noContentPaddings,
    size,
    styles,
    subtitle,
    title,
    titleSize,
}) => {
    const [isOpened, setIsOpened] = useState(false);
    const WrapperComponent = isMobile ? MobileWrapper : DesktopWrapper;

    useEffect(() => {
        const receiveMessage = ({ data }: { data: { eventName?: string; type: string } }) => {
            // data.eventName оставлено для обратной совместимости
            if (data.type === eventName || data.eventName === eventName) {
                setIsOpened(true);
            }
        };

        window.addEventListener('message', receiveMessage, false);

        return () => window.removeEventListener('message', receiveMessage);
    }, [eventName]);

    return (
        <WrapperComponent
            isOpened={isOpened}
            noContentPaddings={noContentPaddings}
            onClose={() => setIsOpened(false)}
            size={size}
            styles={styles}
            subtitle={subtitle}
            title={title}
            titleSize={titleSize}
        >
            {children}
        </WrapperComponent>
    );
};
